// extracted by mini-css-extract-plugin
export default {"overlay":"Modal_overlay__Yzmku","modal":"Modal_modal__ug4nQ","modalCloseButton":"Modal_modalCloseButton__bBhjF","submitBtn":"Modal_submitBtn__wAZQI"};